import React, { PropsWithChildren } from "react"

import { FrontendConfigProvider } from "@cirrus/common/FrontendConfig"
import { getConfig } from "@cirrus/config"

export const FrontendConfigDecorator = ({ children }: PropsWithChildren) =>
  <FrontendConfigProvider config={getConfig()}>{children}</FrontendConfigProvider>
